export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form-reviews.vue?vue&type=template&id=64565f0c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/forms/form-reviews.vue?vue&type=template&id=64565f0c&
// module id = 1018
// module chunks = 0